import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CARDS = [
  {
    title: "COMMON NUMBER",
    desc: "Check today's common numbers",
    to: "/morning-sunday-teer-common-number/",
    img: "/images/common.jpg",
    bg: "#f26a2c",
    testid: "feature-card-common-number",
  },
  {
    title: "PREVIOUS RESULT",
    desc: "View old results and historical data",
    to: "/morning-teer-previous-result/",
    img: "/images/previous.jpg",
    bg: "#0f172a",
    testid: "feature-card-previous-result",
  },
  {
    title: "LIVE UPDATES",
    desc: "Get fast & accurate result updates",
    to: "/blog/",
    img: "/images/live.jpg",
    bg: "#0f766e",
    testid: "feature-card-live-updates",
  },
];

export function FeatureCards() {
  return (
    <section
      data-testid="three-feature-cards"
      className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6"
    >
      {CARDS.map((c, i) => (
        <Link
          key={i}
          to={c.to}
          data-testid={c.testid}
          style={{ backgroundColor: c.bg }}
          className="rounded-2xl card-shadow p-4 sm:p-5 text-white group flex items-center gap-3 min-h-[120px] transition-transform hover:-translate-y-1"
        >
          <img
            src={c.img}
            alt={c.title}
            loading="eager"
            decoding="sync"
            fetchPriority="high"
            className="w-[76px] h-[76px] sm:w-20 sm:h-20 object-cover rounded-xl shrink-0"
          />
          <div className="flex-1 min-w-0">
            <h3 className="font-head font-extrabold text-base sm:text-lg tracking-wide">
              {c.title}
            </h3>
            <p className="text-white/85 text-xs sm:text-sm mt-1 leading-snug">{c.desc}</p>
          </div>
          <span className="w-9 h-9 rounded-full bg-white text-slate-900 flex items-center justify-center shadow shrink-0 group-hover:translate-x-1 transition-transform">
            <ArrowRight size={18} />
          </span>
        </Link>
      ))}
    </section>
  );
}
